import { render, staticRenderFns } from "./main-banner.vue?vue&type=template&id=8695202a&scoped=true"
import script from "./main-banner.vue?vue&type=script&lang=js"
export * from "./main-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8695202a",
  null
  
)

export default component.exports